import styled from 'styled-components';

const HeaderLogo = styled.img`
  height: 1.5rem;
  padding-right: 1.5rem;
  margin-top: -0.25rem;
`;

export default HeaderLogo;
